export const feedbackCategories = ['Error', 'Improvement', 'Idea'] as const
export type FeedbackCategory = (typeof feedbackCategories)[number]

export const feedbackCategoryLabels: Record<FeedbackCategory, string> = {
  Error: 'Fehler',
  Improvement: 'Verbesserung',
  Idea: 'Idee',
}

export const feedbackCategoryPrompts: Record<FeedbackCategory, string> = {
  Error: 'Was ist passiert, was haben Sie erwartet?',
  Improvement: 'Was würde Ihre Arbeit erleichtern?',
  Idea: 'Was möchten Sie ermöglichen?',
}
